import React from 'react';

const LinkedInLogo = ({
  width = 40,
  height = 40,
  fill = 'currentColor',
  responsive = false,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      aria-labelledby="logoTitle"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <title id="logoTitle">LinkedIn</title>
      <path
        d="M14.5808 12C15.4567 12 16.1616 12.7197 16.1403 13.6138C16.1403 14.5079 15.4139 15.2058 14.5594 15.2058C13.6836 15.2058 13 14.4643 13 13.592C13.0427 12.6979 13.7263 12 14.5808 12ZM16.1616 26.873H13V16.5142H16.1616V26.873ZM28.21 26.873H25.0484V21.4429C25.0484 18.1717 21.2245 18.4115 21.2245 21.4429V26.873H18.0842V16.5142H21.2245V17.91C22.549 15.402 28.21 15.2276 28.21 20.3088V26.873Z"
        fill={fill}
      />
    </svg>
  );
};

export default LinkedInLogo;
